let formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 }
}

let tailLayout = {
    wrapperCol: { offset: 6, span: 16 },
}

function ngetBase64(file: any) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export { formItemLayout, tailLayout, ngetBase64 }